import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Grid from '@material-ui/core/Grid';
// import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Slider from '@ant-design/react-slick';
import '../../static/css/style.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import BlogPostGrid from '../blog/BlogPostGrid';
import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';

import {
  getBlogPosts,
} from '../../shared/requests/BlogRequests';

// testimonial data
import TestimonialData from '../../static/testimonial_data';

import HeaderImg from '../../static/img/testimonial_page/TestimonialHeader.webp';
import VidSectionBackground from '../../static/img/testimonial_page/VidSectionBackground.webp';
import ValerieSanchez from '../../static/img/testimonial_page/ValerieSanchez.webp';
import RiverPlumb from '../../static/img/testimonial_page/RiverPlumb.webp';
import SherrellSavage from '../../static/img/testimonial_page/SherrellSavage.webp';
import DiscoverSectionImages from '../../static/img/testimonial_page/DiscoverSectionImages.webp';

const testimonialArray = Object.values(TestimonialData);

const miniSliderTesties = [
  {
    quote: 'Nia makes movement\nfeel like play...',
    quotie: 'Hilde Kaiser',
  },
  {
    quote: 'Nia gets me out of my head\nand into my body.',
    quotie: 'Joanna Richison',
  },
  {
    quote: 'Nia makes me feel\nALIVE!',
    quotie: 'Orit Weichselbaum',
  },
  {
    quote: 'When I dance Nia I feel\nthe power of life!',
    quotie: 'Tuly Karmazin',
  },
  {
    quote: 'I always feel better during\nand afterwards.',
    quotie: 'Claire Lewis',
  },
  {
    quote: 'Nia brings me home\nto myself.',
    quotie: 'Natasha Villeneuve',
  },
];

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    maxWidth: '100%',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'white',
  },
  h1: {
    color: 'white',
    textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    fontSize: '2rem',
    [theme.breakpoints.up(768)]: {
      fontSize: '4rem',
    },
    [theme.breakpoints.up(1024)]: {
      fontSize: '6rem',
    },
  },
  h2: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    fontSize: '2rem',
    [theme.breakpoints.up(768)]: {
      fontSize: '3.7rem',
    },
  },
  grey: {
    color: '#5C5656',
  },
  white: {
    color: 'white',
  },
  header: {
    textAlign: 'center',
    backgroundImage: `url(${HeaderImg})`,
    // backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
    backgroundSize: 'cover',
    width: '100%',
    height: '200px',
    [theme.breakpoints.up(768)]: {
      height: '350px',
    },
    [theme.breakpoints.up(1024)]: {
      height: '500px',
    },
  },
  headerTextContainer: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
    height: '80%',
    // width: '100%',
  },
  headerText: {
    textTransform: 'uppercase',
    letterSpacing: '3px',
    textAlign: 'center',
    fontWeight: '300',
  },
  loadingSpinner: {
    margin: theme.spacing(5),
  },
  miniSliderSection: {
    width: '100%',
    // height: '100px',
    background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.95) -15.25%, rgba(0, 0, 0, 0.60) 70%)',
  },
  miniSlide: {
    marginTop: '20px',
    marginBottom: '20px',
    borderRight: '2px solid white',
    paddingRight: '20px',
    paddingLeft: '20px',
    color: 'white',
    textAlign: 'center',
  },
  miniSlideQuote: {
    fontSize: '16px',
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.up(768)]: {
      fontSize: '22px',
    },
  },
  miniSlideQuotie: {
    fontSize: '12px',
    [theme.breakpoints.up(768)]: {
      fontSize: '18px',
    },

  },
  bigSliderSection: {
    width: '90%',
    margin: '0 auto',
    [theme.breakpoints.up(900 + theme.spacing(2 * 2))]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    marginBottom: theme.spacing(8),
  },
  bigSlider: {
    marginBottom: theme.spacing(8),
    marginTop: theme.spacing(6),
    padding: theme.spacing(),
  },
  testimonialCard: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  testimonialPortrait: {
    margin: '0 auto',
    width: '100%',
    height: 'auto',
    [theme.breakpoints.down(600)]: {
      width: '70%',
    },
  },
  verticalFlex: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  content: {
    lineHeight: 1.8,
  },
  quoteCred: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  container: {
    width: '100%',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up(900 + theme.spacing(2 * 2))]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  videoSection: {
    width: '100%',
    height: 'auto',
    backgroundImage: `url(${VidSectionBackground})`,
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
    backgroundSize: 'cover',
    textAlign: 'center',
    paddingBottom: theme.spacing(8),
  },
  vidSectionName: {
    paddingTop: theme.spacing(),
    color: 'white',
    textTransform: 'uppercase',
    fontSize: '15px',
    letterSpacing: '0.2em',
    fontWeight: '500',
    [theme.breakpoints.down(1024)]: {
      paddingBottom: theme.spacing(5),
    },
  },
  threeVidSection: {
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  videoSectionImg: {
    '&:hover': {
      transform: 'scale(1.05, 1.05)',
    },
    height: 'auto',
    width: '60%',
    // [theme.breakpoints.up(768)]: {
    //   width: '80%',
    // },
    [theme.breakpoints.up(1024)]: {
      width: '100%',
    },
  },
  imgSection: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  imgSectionImage: {
    width: '100%',
    height: 'auto',
  },
  testimonialSection: {
    marginBottom: theme.spacing(5),
  },
});

const TestimonialCard = ({
  classes, portrait, quote, quotee, alt,
}) => (
    // eslint-disable-next-line react/jsx-indent
    <Grid className={classes.testimonialCard} container spacing={4}>
      <Grid item xs={12} sm={4}>
        <img className={classes.testimonialPortrait} alt={alt} src={portrait} />
      </Grid>
      <Grid item xs={12} sm={8} className={classes.verticalFlex}>
        <div className={classes.verticalFlex}>
          <Typography variant="body1" color="textSecondary" className={classes.content}>{quote}</Typography>
          <br />
          <Typography variant="body1" color="textSecondary" className={classes.quoteCred}>{quotee}</Typography>
        </div>
      </Grid>
    </Grid>
    // eslint-disable-next-line indent
  );

class TestimonialsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      testimonials: {},
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    getBlogPosts({ pageSize: this.pageSize, category: 'Testimonial' })
      .then((response) => {
        this.setState({
          testimonials: response.data,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to fetch blog posts.',
        });
      });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  render() {
    const { classes } = this.props;
    const {
      testimonials,
      loading,
      snackbarOpen,
      snackbarMessage,
      snackbarVariant,
    } = this.state;

    const bigSliderSettings = {
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 10000,
    };

    const miniSliderSettings = {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      speed: 9000,
      autoplaySpeed: 0,
      cssEase: 'linear',
      arrows: false,
      centered: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    return (
      <div className={classes.page}>
        <NavBar />
        <div className={classes.appBarSpacer} />
        <div className={classes.header}>
          <div className={classes.headerTextContainer}>
            <Typography className={classNames(classes.headerText, classes.h1)} color="textSecondary" variant="h1">Testimonials</Typography>
          </div>
        </div>
        <div className={classes.miniSliderSection}>
          <Slider className={classes.miniSlider} {...miniSliderSettings}>
            {miniSliderTesties.map(testi => (
              <div key={testi.quotie} className={classes.miniSlide}>
                <Typography variant="body1" className={classes.miniSlideQuote}>{testi.quote}</Typography>
                <Typography variant="body2" className={classes.miniSlideQuotie}>{'— ' + testi.quotie}</Typography>
              </div>
            ))}
          </Slider>
        </div>
        <div className={classes.bigSliderSection}>
          <Typography variant="h2" className={classNames(classes.headerText, classes.h2, classes.grey)}>What People are Saying</Typography>
          <Slider className={classes.bigSlider} {...bigSliderSettings}>
            {testimonialArray.map(testimonial => (
              <TestimonialCard
                portrait={testimonial.photo}
                quote={testimonial.quote}
                quotee={testimonial.name}
                key={testimonial.name}
                alt={testimonial.alt}
                classes={classes}
              />
            ))}
          </Slider>
        </div>
        <div className={classes.videoSection}>
          <Typography variant="h2" className={classNames(classes.headerText, classes.h2, classes.white)}>Transformational Stories</Typography>
          <Grid container className={classes.threeVidSection}>
            <Grid item xs={12} md={3}>
              <a href="https://www.youtube.com/watch?v=4_AhOpfYuaw&list=PL1vDap4XHC6aFyZw-jMc7k8D8PTlZkzcP&index=3" target="_blank" rel="noopener noreferrer">
                <img src={ValerieSanchez} className={classes.videoSectionImg} alt="Valerie Sanchez, transformational nia student" />
              </a>
              <Typography variant="h4" className={classes.vidSectionName}>Valerie Sanchez</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <a href="https://www.youtube.com/watch?v=NCx-GxyPmuA&list=PL1vDap4XHC6aFyZw-jMc7k8D8PTlZkzcP&index=7" target="_blank" rel="noopener noreferrer">
                <img src={RiverPlumb} className={classes.videoSectionImg} alt="River Plumb, transformational nia student" />
              </a>
              <Typography variant="h4" className={classes.vidSectionName}>River Plumb</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <a href="https://www.youtube.com/watch?v=u1h0kSEtmAI&list=PL1vDap4XHC6aFyZw-jMc7k8D8PTlZkzcP&index=2" target="_blank" rel="noopener noreferrer">
                <img src={SherrellSavage} className={classes.videoSectionImg} alt="Sherrell Savage, transformational nia student" />
              </a>
              <Typography variant="h4" className={classes.vidSectionName}>Sherrell Savage</Typography>
            </Grid>
          </Grid>
        </div>
        <div className={classNames(classes.container, classes.imgSection)}>
          <img src={DiscoverSectionImages} className={classes.imgSectionImage} alt="the word discover in cursive with various people dancing" />
        </div>
        <div className={classes.container}>
          <div className={classes.testimonialSection}>
            {loading
              ? <CircularProgress className={classes.loadingSpinner} />
              : (
                <React.Fragment>
                  {testimonials.length > 0 && <BlogPostGrid posts={testimonials} />}
                </React.Fragment>
              )
            }
          </div>
        </div>
        <FooterSpacer />
        <Footer />

        {/* SNACKBAR */}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={snackbarVariant}
            message={snackbarMessage}
          />
        </Snackbar>
      </div>
    );
  }
}

TestimonialsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

TestimonialCard.propTypes = {
  classes: PropTypes.object.isRequired,
  portrait: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  quotee: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default withStyles(styles)(TestimonialsPage);
